import '@babel/polyfill'
import storage from './storage'

storage().then(() => {}, console.warn)
